module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/la-spezia.321457d4253d5824f97440e2ffd04237.jpg";